export const SITE = {
  name: "SAIVU",
  legalName: "Saivu Consulting Pvt Ltd",
  domain: "saivu.in",
  url: "https://saivu.in",
  tagline: "Professional consulting for business, finance, tax & compliance",
  phoneDisplay: "+91 96675 12380",
  phoneTel: "+919667512380",
  whatsapp:
    "https://wa.me/919667512380?text=Hello%2C%20I%27d%20like%20to%20consult%20a%20CA.",
  email: "Support@saivu.in",
  address: "Office No. 411, Fourth Floor, Angel Mega Mall, Kaushambi, Ghaziabad",
  addressShort: "Angel Mega Mall, Kaushambi, Ghaziabad",
};

export const STATS = [
  { value: "4,700+", label: "Customers served" },
  { value: "15+", label: "Years of expertise" },
  { value: "4.9/5", label: "Google rating" },
  { value: "22", label: "States covered" },
];

export const PROCESS = [
  {
    num: "01",
    title: "Free 20-minute consultation",
    desc: "Speak to a qualified chartered accountant about your requirement — no sales pitch, just the right next step.",
  },
  {
    num: "02",
    title: "Transparent proposal",
    desc: "Fixed fees, timelines and deliverables shared in writing before you commit to anything.",
  },
  {
    num: "03",
    title: "50% advance & kick-off",
    desc: "Work begins the same day your advance payment and KYC are in.",
  },
  {
    num: "04",
    title: "Real-time updates",
    desc: "A dedicated point of contact keeps you posted on WhatsApp and email — you're never chasing status.",
  },
  {
    num: "05",
    title: "Delivery & 50% balance",
    desc: "You review every deliverable before the balance is due. Fair for you, fair for us.",
  },
];

export const WHY_US = [
  {
    title: "15+ years of expertise",
    desc: "Founded by a chartered accountant with MNC and international audit exposure across continents.",
  },
  {
    title: "Multi-disciplinary team",
    desc: "Chartered accountants, advocates, MBAs and compliance experts working under one roof.",
  },
  {
    title: "Fixed & transparent fees",
    desc: "No hidden charges. A 50-50 payment structure keeps trust intact on both sides.",
  },
  {
    title: "PAN-India + NRI ready",
    desc: "500+ active clients across 22 states, onboarded fully remotely.",
  },
  {
    title: "Tech-enabled delivery",
    desc: "Cloud dashboards, WhatsApp updates and digital signatures — compliance that never waits on paper.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "From incorporation to GST to trademark — the team has been our finance partner from day one. The 50-50 payment structure gave us confidence, and delivery was faster than promised.",
    name: "Ritika Sharma",
    role: "Founder · Bloomlane (D2C skincare)",
  },
  {
    quote:
      "Their Virtual CFO service transformed our board reporting. We closed our pre-Series A in half the expected time because our data room was investor-ready.",
    name: "Arjun Mehta",
    role: "CTO · Truxis SaaS",
  },
  {
    quote:
      "As an NRI, tax compliance in India was a nightmare — until this team took over. Everything now happens remotely, on time, with zero chasing.",
    name: "Neha Verma",
    role: "Freelance Consultant · Dubai",
  },
  {
    quote:
      "FSSAI, ISO 22000, GST, ROC — one team, one dashboard, zero missed deadlines in three years. Truly the firm we wish we had found earlier.",
    name: "Rahul Iyer",
    role: "Director · Iyer Foods Pvt Ltd",
  },
];

export const FAQS = [
  {
    q: "Who is behind SAIVU?",
    a: "SAIVU is operated by Saivu Consulting Pvt Ltd and led by a senior chartered accountant with over 15 years of MNC and international audit experience.",
  },
  {
    q: "How does the 50% + 50% payment structure work?",
    a: "Half of the professional fee is payable before work commences, and the remaining half only after successful completion and delivery. You review every deliverable before the balance is due.",
  },
  {
    q: "Is the first consultation really free?",
    a: "Yes. You get 20 minutes with a qualified chartered accountant — no sales pitch, just honest advice on the right next step for your business.",
  },
  {
    q: "Are you a CA firm?",
    a: "No. SAIVU is a professional consulting company, not a chartered accountancy practice. Our multidisciplinary team includes Chartered Accountants, advocates, MBA Finance professionals and compliance specialists, so tax, legal and advisory work never falls between chairs.",
  },
  {
    q: "Do you serve NRIs and foreign clients?",
    a: "Yes. Clients outside India — including NRIs — are onboarded fully remotely: document collection, filings and updates all happen over WhatsApp, email and video calls.",
  },
  {
    q: "How quickly can you start work?",
    a: "Usually the same day — once the 50% advance is paid and your KYC documents are in, we begin immediately.",
  },
  {
    q: "Do you offer refunds?",
    a: "Our fees are tied to deliverables: you review the completed work before the final payment is due. For specific situations, raise it in your free consultation and we will put the terms in writing.",
  },
  {
    q: "How do you protect my data?",
    a: "Files are stored on encrypted cloud drives with two-factor authentication. Access is limited to engagement-specific team members bound by CA-code confidentiality.",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Journal", to: "/journal" },
  { label: "Contact", to: "/contact" },
];
